// extracted by mini-css-extract-plugin
export default {"MainLayout":"mainLayout_MainLayout__34yCh","wrapper":"mainLayout_wrapper__WkMUC"};